/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { BackButton, useApiClient, useFetch } from '@marageti/z4-lib';
import { Review } from '@marageti/z4-sdk/lib/travel';
import { FieldValues, SubmitHandler } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import {
  Box, Container, Skeleton, Stack,
} from '@mui/material';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import EditReviewForm from './edit-review-form';

const EditReviewContainer = () => {
  const navigate = useNavigate();
  const { reviewId } = useParams();
  const apiClient = useApiClient();

  const { data: review, isLoading, mutate } = useFetch<Review>(apiClient.reviewsClient.getReview, [reviewId], !!reviewId);
  const [submissionError, setSubmissionError] = useState<ApiError>();

  const goBack = () => navigate(-1);

  const onSubmit: SubmitHandler<FieldValues> = async (data) => {
    setSubmissionError(undefined);
    try {
      if (!review) {
        throw new Error('No review found');
      }

      const updatedReview: Review = {
        ...review,
        published: data.published !== 'Unpublished',
        agentReply: { ...review.agentReply, reply: data.agentReply },
        title: data.title,
        mainReview: data.mainReview,
        bestParts: data.bestParts,
        doDifferently: data.doDifferently,
        rating: data.rating * 20,
      };
      await apiClient.reviewsClient.putReview(review.id!, updatedReview);
      mutate();
      enqueueSnackbar('Review saved.', { variant: 'success' });
      goBack();
    } catch (e: any) {
      if (e.code === 401) navigate('/logout');
      setSubmissionError(e);
    }
  };

  const onCancel = () => goBack();

  return (
    <Container
      maxWidth="md"
      sx={{ pb: 8 }}
    >
      <Box
        sx={{
          py: {
            desktop: 6,
            mobile: 3,
          },
        }}
      >
        <BackButton onClick={goBack} edge="start" sx={{ mb: 2 }} />
        {(isLoading) ? (
          <Stack spacing={2} mt="20px">
            {Array(10).fill(null).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
              <Skeleton key={index} variant="rounded" height="43px" width="100%" />
            ))}
          </Stack>
        ) : (
          <EditReviewForm
            review={review}
            submissionError={submissionError}
            onCancel={onCancel}
            onSubmit={onSubmit}
          />
        )}
      </Box>
    </Container>
  );
};

export default EditReviewContainer;
